export default "__VITE_ASSET__CdqvygGK__"